import { NavigateOptions, useNavigate } from "react-router-dom";

const usePathNavigate = () => {
    const navigate = useNavigate();

    const pathNavigate = (path: string, option?: NavigateOptions) => {
        navigate(path, { state: { path: "path" }, ...option });
    };

    const backNavigate = (depth: number = -1) => {
        navigate(depth);
    };

    return { pathNavigate, backNavigate };
};

export default usePathNavigate;
